/* Sevine Dumont: cart drawer + cart page + extras pop-up (replicatie K1/K2, 01-10-2026).
   Drawer content = sections/sd-k1-cart-drawer.liquid, pop-up = sections/sd-k2-upsell-popup.liquid,
   both from /cart?view=sd-drawer (templates/cart.sd-drawer.json).
   Public API: window.SDCart.open(), .close(), .refresh(), .add(formDataOrItems)
   Events in:  sd:cart:added, sd:cart:refresh, sd:cart:open (on document)
   Events out: sd:cart:updated { item_count, cart } (on document) */
(function () {
  if (window.SDCart && window.SDCart.__ready) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SS_KEY = 'sd-cart-drawer-sections-k1';
  var k2Ready = false;
  var TIMER_KEY = 'sd-timer-cart';
  var drawer = null;
  var loaded = false;
  var loading = null;
  var lastFocus = null;
  var noteTimer = null;
  var lastCart = null;

  function ss(method, key, value) {
    try { return window.sessionStorage[method](key, value); } catch (e) { return null; }
  }

  function withPreview(url) {
    var p = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!p || url.indexOf('preview_theme_id=') > -1) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(p);
  }

  function getDrawer() {
    if (!drawer) drawer = document.querySelector('[data-sd-cart-drawer]');
    return drawer;
  }

  function onCartPage() {
    return !!document.querySelector('[data-sd-cart-page]');
  }

  function parseRoot(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-sd-cart-root]');
  }

  /* ---------- drawer content ---------- */
  function parseK2(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-sd-k2]');
  }

  /* K2: put the pop-up markup in the host next to the drawer (once, and never while it is open). */
  function installK2(el) {
    if (!el) return;
    var host = document.querySelector('[data-sd-k2-host]');
    if (!host) return;
    var current = host.querySelector('[data-sd-k2]');
    if (current && !current.hidden) return;
    var node = document.importNode(el, true);
    node.hidden = true;
    node.classList.remove('sd-k2--preview');
    host.replaceChildren(node);
    k2Ready = true;
  }

  function fetchDrawerRoot() {
    var d = getDrawer();
    if (!d) return Promise.resolve(null);
    var base = d.dataset.url;
    var ids = ss('getItem', SS_KEY);
    var viaSections = ids
      ? fetch(withPreview(base + '&sections=' + encodeURIComponent(ids)), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var parts = ids.split(',');
            if (!j || !j[parts[0]]) return null;
            if (parts[1] && j[parts[1]]) installK2(parseK2(j[parts[1]]));
            return parseRoot(j[parts[0]]);
          })
          .catch(function () { return null; })
      : Promise.resolve(null);
    return viaSections.then(function (root) {
      if (root) return root;
      return fetch(withPreview(base), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var r = parseRoot(html);
          var k2 = parseK2(html);
          installK2(k2);
          if (r && r.dataset.sectionId) {
            ss('setItem', SS_KEY, r.dataset.sectionId + (k2 && k2.dataset.sectionId ? ',' + k2.dataset.sectionId : ''));
          }
          return r;
        });
    });
  }

  function refreshDrawer() {
    var d = getDrawer();
    if (!d) return Promise.resolve();
    if (loading) return loading;
    loading = fetchDrawerRoot().then(function (root) {
      loading = null;
      if (!root) return;
      var content = d.querySelector('[data-sd-drawer-content]');
      var scroll = content.querySelector('[data-sd-cart-scroll]');
      var top = scroll ? scroll.scrollTop : 0;
      content.replaceChildren(document.importNode(root, true));
      var newScroll = content.querySelector('[data-sd-cart-scroll]');
      if (newScroll) newScroll.scrollTop = top;
      loaded = true;
      afterRender(+root.dataset.itemCount || 0);
    }).catch(function () { loading = null; });
    return loading;
  }

  /* ---------- cart page ---------- */
  function refreshPage() {
    var page = document.querySelector('[data-sd-cart-page]');
    if (!page) return Promise.resolve();
    var sid = page.dataset.sectionId;
    return fetch(withPreview(window.location.pathname + '?sections=' + encodeURIComponent(sid)), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var root = j && j[sid] ? parseRoot(j[sid]) : null;
        var current = page.querySelector('[data-sd-cart-root]');
        if (!root || !current) return;
        current.replaceWith(document.importNode(root, true));
        afterRender(+root.dataset.itemCount || 0);
      })
      .catch(function () { window.location.reload(); });
  }

  function afterRender(count) {
    if (count === 0) ss('removeItem', TIMER_KEY);
    document.querySelectorAll('[data-sd-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
      el.toggleAttribute('data-empty', count === 0);
    });
    if (window.SD && window.SD.reveal) window.SD.reveal(document);
    /* 06-10: no fake resize while the drawer is open (it made the page behind it relayout during the slide) */
    if (!isOpen()) window.dispatchEvent(new Event('resize'));
  }

  function refresh() {
    var jobs = [];
    if (onCartPage()) jobs.push(refreshPage());
    if (getDrawer() && (loaded || isOpen())) jobs.push(refreshDrawer());
    return Promise.all(jobs).then(function () {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          afterRender(cart.item_count);
          document.dispatchEvent(new CustomEvent('sd:cart:updated', { detail: { item_count: cart.item_count, cart: cart } }));
          return cart;
        })
        .catch(function () {});
    });
  }

  /* ---------- open / close ---------- */
  function isOpen() {
    var d = getDrawer();
    return !!(d && d.open);
  }

  /* 06-10 (Jesse, iPhone): the drawer glitched (sometimes from the left, a jolt on tap). Causes:
     1. showModal() focuses the first control inside the panel while the panel still sits off-screen to the
        right; the browser then scrolls the overflow:hidden dialog sideways to show it, so the panel jumped
        and seemed to come from the other side. Fix: dialog overflow: clip (cannot scroll) + scrollLeft reset
        + focus the close button with preventScroll.
     2. The content was swapped in the middle of the slide (empty shell -> full cart) and a fake resize
        event was fired at the end. Fix: wait briefly for the content, then slide; no resize event.
     3. Re-opening during the close (and closing during the open) fought over the same class.
     One transform only: translate3d(100%,0,0) -> 0, ease-out 380 ms (CSS in sd-cart.css). */
  var closeTimer = null;
  var openToken = 0;

  /* 09-10 16u (Jesse): the close button showed a square frame. The drawer focuses that button on open, and some
     browsers (Safari, iPhone) then draw the theme focus ring. The ring now only shows after the Tab key. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') document.documentElement.classList.add('sd-kbd');
  }, true);
  document.addEventListener('pointerdown', function () {
    document.documentElement.classList.remove('sd-kbd');
  }, true);

  function slideIn(d) {
    var panel = d.querySelector('[data-sd-drawer-panel]');
    d.scrollLeft = 0;
    d.scrollTop = 0;
    /* commit the closed position (translateX 100%) before adding .is-open, so it always slides from the right */
    d.classList.remove('is-open');
    void (panel || d).getBoundingClientRect();
    d.classList.add('is-open');
    var btn = d.querySelector('[data-sd-cart-close]');
    if (btn && btn.focus) {
      try { btn.focus({ preventScroll: true }); } catch (e) {}
    }
    d.scrollLeft = 0;
  }

  function open() {
    var d = getDrawer();
    if (!d || onCartPage()) {
      window.location.href = ROOT + 'cart';
      return;
    }
    if (closeTimer) {
      /* tapped again while it was closing: slide back in from where it is */
      window.clearTimeout(closeTimer);
      closeTimer = null;
      d.classList.add('is-open');
      return;
    }
    if (d.open) return;
    var token = ++openToken;
    var show = function () {
      if (token !== openToken || d.open) return;
      lastFocus = document.activeElement;
      document.documentElement.classList.add('sd-cart-open');
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      slideIn(d);
    };
    if (loaded) { show(); return; }
    /* content not there yet: wait for it (at most 600 ms), so nothing jumps during the slide */
    var done = false;
    var go = function () { if (!done) { done = true; show(); } };
    window.setTimeout(go, 600);
    refreshDrawer().then(go, go);
  }

  function close() {
    var d = getDrawer();
    openToken++;
    if (!d || !d.open || closeTimer) return;
    d.classList.remove('is-open');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeTimer = window.setTimeout(function () {
      closeTimer = null;
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
      document.documentElement.classList.remove('sd-cart-open');
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    }, reduce ? 0 : 400);
  }

  /* ---------- cart changes ---------- */
  function rootOf(el) {
    return el.closest('[data-sd-cart-root]');
  }

  function showError(scope, message) {
    var root = scope && rootOf(scope);
    var target = (scope && scope.querySelector('[data-sd-line-error]')) || (root && root.querySelector('[data-sd-cart-error]'));
    if (!target) return;
    target.textContent = message || (root && root.dataset.errorText) || '';
    target.hidden = false;
  }

  function changeLine(line, quantity) {
    var key = line.dataset.key;
    line.classList.add('is-busy');
    line.setAttribute('aria-busy', 'true');
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          line.classList.remove('is-busy');
          line.removeAttribute('aria-busy');
          showError(line, res.body && (res.body.description || res.body.message));
          return;
        }
        return refresh();
      })
      .catch(function () {
        line.classList.remove('is-busy');
        line.removeAttribute('aria-busy');
        showError(line);
      });
  }

  function saveNote(value) {
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      }).catch(function () {});
    }, 500);
  }

  /* ---------- K2 extras pop-up ---------- */
  function k2El() {
    return document.querySelector('[data-sd-k2-host] [data-sd-k2]');
  }

  function k2Money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var v = (cents || 0) / 100;
    return cur + ' ' + (v % 1 === 0 ? String(v) : v.toFixed(2));
  }

  function showK2(item) {
    var el = k2El();
    if (!el || !el.hasAttribute('data-enabled') || !item) return false;
    var img = el.querySelector('[data-sd-k2-img]');
    if (img) {
      var src = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (src) {
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=100';
        img.alt = item.product_title || '';
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }
    var name = el.querySelector('[data-sd-k2-name]');
    if (name) name.textContent = item.product_title || item.title || '';
    var price = el.querySelector('[data-sd-k2-price]');
    if (price) price.textContent = k2Money(item.final_price != null ? item.final_price : item.price);
    /* Fix 03-10: an extra that is already in the cart shows as ADDED, so it cannot be added twice */
    var inCart = {};
    if (lastCart && lastCart.items) lastCart.items.forEach(function (i) { inCart[i.variant_id] = true; });
    el.querySelectorAll('[data-sd-k2-add][data-variant]').forEach(function (b) {
      if (!b.dataset.label) b.dataset.label = b.textContent;
      var added = !!inCart[+b.dataset.variant];
      b.disabled = added;
      b.classList.toggle('is-added', added);
      b.textContent = added ? (el.dataset.addedLabel || b.dataset.label) : b.dataset.label;
    });
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.classList.add('sd-cart-open');
    void el.offsetWidth;
    el.classList.add('is-open');
    var c = el.querySelector('[data-sd-k2-continue]');
    if (c) c.focus({ preventScroll: true });
    return true;
  }

  function hideK2(thenOpen) {
    var el = k2El();
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    el.hidden = true;
    document.documentElement.classList.remove('sd-cart-open');
    if (thenOpen) open();
  }

  function addOffer(btn) {
    var id = btn.dataset.variant;
    if (!id || btn.classList.contains('is-added')) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        var el = k2El();
        if (!btn.dataset.label) btn.dataset.label = btn.textContent;
        btn.textContent = (el && el.dataset.addedLabel) || btn.textContent;
        btn.classList.add('is-added');
        btn.removeAttribute('aria-busy');
        loaded = false;
        refresh();
      })
      .catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }

  function add(body, opts) {
    opts = opts || {};
    var opts;
    if (body instanceof FormData) {
      opts = { method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    } else {
      var payload = Array.isArray(body) ? { items: body } : body;
      opts = { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    }
    return fetch(ROOT + 'cart/add.js', opts)
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(function (added) {
        loaded = false;
        return refresh().then(function () {
          if (getDrawer() && !onCartPage()) {
            return refreshDrawer().then(function () {
              var item = added && added.items ? added.items[0] : added;
              if (opts.noUpsell || !showK2(item)) open();
              return added;
            });
          }
          return added;
        });
      });
  }

  function formError(form, message) {
    var el = form.querySelector('[data-sd-add-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'sd-form-message sd-form-message--error';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-sd-add-error', '');
      form.appendChild(el);
    }
    el.textContent = message || 'That did not work. Please try again.';
    el.hidden = false;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-sd-cart-open]');
    if (opener && getDrawer() && !onCartPage()) {
      e.preventDefault();
      open();
      return;
    }
    if (t.closest('[data-sd-k2-close]') || t.closest('[data-sd-k2-continue]')) {
      e.preventDefault();
      hideK2(true);
      return;
    }
    var offer = t.closest('[data-sd-k2-add]');
    if (offer) {
      e.preventDefault();
      addOffer(offer);
      return;
    }
    var arrow = t.closest('[data-sd-k1-prev], [data-sd-k1-next]');
    if (arrow) {
      var slider = arrow.closest('[data-sd-k1-slider]');
      var track = slider && slider.querySelector('[data-sd-k1-track]');
      var card = track && track.firstElementChild;
      if (track && card) {
        var step = card.getBoundingClientRect().width;
        track.scrollBy({ left: arrow.hasAttribute('data-sd-k1-prev') ? -step : step, behavior: 'smooth' });
      }
      return;
    }
    if (t.closest('[data-sd-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var qtyBtn = t.closest('[data-sd-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-sd-cart-line]');
      var input = line && line.querySelector('[data-sd-qty-input]');
      if (!input) return;
      var q = parseInt(input.value, 10) || 0;
      q = qtyBtn.dataset.sdQty === 'plus' ? q + 1 : Math.max(0, q - 1);
      input.value = q;
      changeLine(line, q);
      return;
    }
    var rm = t.closest('[data-sd-remove]');
    if (rm) {
      changeLine(rm.closest('[data-sd-cart-line]'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-sd-qty-input]');
    if (!input) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.closest('[data-sd-cart-line]'), q);
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-sd-cart-note]')) saveNote(e.target.value);
  });

  // Audit 01-10: "For yourself or a gift?" saved as cart attribute; a gift opens the note for a message.
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-sd-cart-gift]');
    if (!r) return;
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Purchase for': r.value } })
    }).catch(function () {});
    var scope = r.closest('.sd-scope') || document;
    var note = scope.querySelector('.sd-cnote');
    if (note && r.hasAttribute('data-gift')) note.open = true;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (!getDrawer() || onCartPage() || form.hasAttribute('data-sd-no-drawer')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var old = form.querySelector('[data-sd-add-error]');
    if (old) old.hidden = true;
    add(new FormData(form), { noUpsell: form.hasAttribute('data-sd-no-upsell') })
      .catch(function (err) { formError(form, err && (err.description || err.message)); })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  });

  ['pointerenter', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (loaded || loading || !e.target.closest || !e.target.closest('[data-sd-cart-open]')) return;
      refreshDrawer();
    }, true);
  });

  document.addEventListener('sd:cart:added', function (e) {
    /* The drawer handles this add: tell the sender not to go to /cart (fix B3). */
    if (getDrawer() && !onCartPage() && e && e.cancelable) e.preventDefault();
    loaded = false;
    var det = (e && e.detail) || {};
    /* K2: an add from the product page (sd-product sends sectionId) shows the extras pop-up first. */
    var item = det.sectionId && det.item ? (det.item.items ? det.item.items[0] : det.item) : null;
    refresh().then(function () {
      if (onCartPage()) return;
      refreshDrawer().then(function () {
        if (!showK2(item)) open();
      });
    });
  });
  document.addEventListener('sd:cart:refresh', function () { refresh(); });
  document.addEventListener('sd:cart:open', function () { open(); });

  /* K1: "Expected delivery" as "06 October" (CAINTÈ), from the shared delivery estimate. */
  document.addEventListener('sd:delivery:update', function (e) {
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-sd-k1-date') || !e.detail) return;
    var d = new Date(e.detail.max);
    var out = el.querySelector('[data-sd-date-max]');
    if (out && !isNaN(d)) {
      out.textContent = String(d.getUTCDate()).padStart(2, '0') + ' ' + d.toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var el = k2El();
      if (el && !el.hidden) hideK2(true);
    }
  });

  function bindDialog() {
    var d = getDrawer();
    if (!d || d.__sdBound) return;
    d.__sdBound = true;
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindDialog);
  else bindDialog();

  /* R8a (02-10): load the drawer content once the page is idle, so the panel slides in full (touch has no hover prefetch). */
  window.addEventListener('load', function () {
    var go = function () { if (!loaded && !loading && getDrawer() && !onCartPage()) refreshDrawer(); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 3000 }); else window.setTimeout(go, 1500);
  });

  window.SDCart = {
    open: open, close: close, refresh: refresh, add: add,
    /* For checks in the preview: show the K2 pop-up for a line item without adding anything. */
    showUpsell: function (item) { return refreshDrawer().then(function () { return showK2(item); }); },
    __ready: true
  };
})();
